import type { ImageAnalyses } from '@/@types/latestImagesV2';

import { SingleImageItem } from './SingleImageItem';

type FmxLayoutProps = {
  fmxGrid: (ImageAnalyses | null)[];
  header: string;
  annotated: boolean;
};

export const FmxLayout = ({ fmxGrid, header, annotated }: FmxLayoutProps) => {
  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-h-fit">
      <h4 className="vai-text-left vai-w-full vai-text-sm vai-font-medium">
        {header}
      </h4>
      <div className="vai-bg-slate-200 vai-h-fit vai-py-4 vai-px-6 vai-rounded-lg">
        <div className="vai-grid vai-grid-cols-7 vai-grid-rows-3 vai-w-[1448px] vai-mx-auto vai-gap-y-4">
          {fmxGrid.map((slot, index) => (
            <div
              key={`${slot?.imageId}-${index}`}
              className="vai-w-150 vai-h-150 vai-bg-none-300 vai-flex vai-items-center vai-justify-center"
            >
              {slot ? (
                <SingleImageItem
                  image={slot}
                  enabledFindings={
                    annotated ? ['calculus', 'radiographic_boneloss'] : []
                  }
                  height={200}
                  width={200}
                />
              ) : (
                <span className="vai-w-full vai-h-full"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
